import styled from 'styled-components';
import { Panel } from 'next/components/ui';
import { PaginationMessage } from 'components/Common/UI/Pagination/Pagination';

export const ProfilePanel = styled(Panel)`
  padding: 0;
  min-width: 1100px;
`;

export const PanelHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px;
  border-bottom: 1px solid var(--tint-black);
`;

export const Subtitle = styled.span``;

export const PanelTitle = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableWrapper = styled.div`
  min-height: 388px;
  position: relative;
`;

export const PaginationInformation = styled(PaginationMessage)`
  right: 42px;
`;

export const Footer = styled.footer`
  display: flex;
  position: relative;
  height: 52px;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--tint-black);
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 388px;
`;

export const NoResultsMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 388px;
  flex-direction: column;
  gap: 16px;
  position: absolute;
`;

export const NoResultsMessageEmphasis = styled.strong`
  font-size: 20px;
  font-weight: var(--semi-bold);
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const SubheaderLabel = styled.span`
  font-weight: bold;
`;

export const NavListItem = styled.li`
  display: inline-block;
  width: 200px;
  padding: 18px 0;
  text-align: center;

  ${props => props.$active && 'border-bottom: 2px solid var(--link);'}

  &:hover {
    ${props => props.$active && 'border-bottom: 2px solid var(--link-hover);'}
  }
`;

export const NavList = styled.ol``;

export const Navigation = styled.nav`
  display: flex;
  flex-direction: row;
  background-color: var(--white);
  box-shadow: var(--level-1);
`;
